import { render } from "./AppointAuth.vue?vue&type=template&id=4fd7f7d6"
import script from "./AppointAuth.vue?vue&type=script&lang=js"
export * from "./AppointAuth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__